import Breadcrumb from "../../components/Breadcrumbs/Breadcrumb"
import StudentProfileCard from "../../components/Students/StudentProfileCard"

const StudentProfile = () => {
  return (
    <>
      <Breadcrumb pageName="Student Profile" />
      <StudentProfileCard />
    </>
  )
}

export default StudentProfile